import React, { useEffect } from "react";
import { BannerSlider, ListCards } from "components/organisms";
import Section from "components/molecules/section";
import { Text } from "components/atoms";
import "./styles.scss";
import { bankEntities } from "assets/images/home/bank-entities";
import { useTranslation } from "react-i18next";

const PromotionsQuota = () => {
  const { i18n, t } = useTranslation();

  const listPromotionQuota = [
    {
      description: [
        {
          id: 1,
          content: t("offers-banks.bcpBenefit"),
        },
        {
          id: 2,
          content: t("offers-banks.bcpExclusions"),
        },
        {
          id: 3,
          content: t("offers-banks.bcpPayment"),
        },
        {
          id: 4,
          content: t("offers-banks.bcpValidity"),
        },
        {
          id: 5,
          content: t("offers-banks.bcpConditions"),
        },
        {
          id: 6,
          content: t("offers-banks.bcpDisclaimer"),
        },
      ],
      id: 1,
      nombre: "PROMOCION BCP",
      redireccion: `/${i18n.language}/${t("routes.offers")}/cuenta-sueldo-bcp`,
      card: {
        tipo_disenio: {
          id: 1,
          titulo: "Oferta con color de fondo",
        },
        titulo_card: "",
        condicion_abajo_precio: "",
        texto_encima_precio: "",
        valor: 35,
        up_to_quotes: "12",
        titulo: "Cuenta Sueldo BCP",
        subtitulo: "Hasta 12 cuotas sin intereses",
        logo: {
          name: "f67c3ec2-29cb-4b13-8f79-b101c1f78338",
          path: "https://s3.us-east-1.amazonaws.com/ca-webprod/Entidad/f67c3ec2-29cb-4b13-8f79-b101c1f78338.png",
          width: 1024,
          height: 258,
          size: 11885,
          title: null,
          alt: null,
          description: null,
          caption: null,
        },
        img: null,
        color: "rgba(0, 42, 142, 1)",
        color_secundario: "rgba(0, 42, 142,1)",
        color_fuente: "rgba(255, 255, 255, 1)",
        precio: 0,
        precio_anterior: 0,
        igv: 0,
        descuento: 0,
        descuento_life: 0,
      },
    },
    {
      description: [
        {
          id: 1,
          content: t("offers-banks.validityPeriod"),
        },
        {
          id: 2,
          content: t("offers-banks.validForServices"),
        },
        {
          id: 3,
          content: t("offers-banks.paymentConditions"),
        },
        {
          id: 4,
          content: t("offers-banks.installments"),
        },
        {
          id: 5,
          content: t("offers-banks.webRate"),
        },
        {
          id: 6,
          content: t("offers-banks.interbankDisclaimer"),
        },
      ],
      id: 2,
      nombre: "Cuenta sueldo INTERBANK Q2 2025",
      redireccion: `/${i18n.language}/${t(
        "routes.offers"
      )}/interbank-cuenta-sueldo`,
      card: {
        tipo_disenio: {
          id: 1,
          titulo: "Oferta con color de fondo",
        },
        titulo_card: "",
        condicion_abajo_precio: "",
        texto_encima_precio: "",
        valor: 35,
        up_to_quotes: "12",
        titulo: "Cuenta Sueldo hasta",
        subtitulo: "Y hasta 12 cuotas sin intereses",
        logo: {
          name: "interbank",
          path: "https://s3.us-east-1.amazonaws.com/ca-webprod/media/interbank.webp",
          width: 1101,
          height: 200,
          size: 16074,
          title: "Interbank",
          alt: "Interbank",
          description: "Interbank",
          caption: "Interbank",
        },
        img: null,
        color: "rgba(6, 190, 79)",
        color_secundario: "rgba(6, 190, 79)",
        color_fuente: "rgba(255, 255, 255, 1)",
        precio: 0,
        precio_anterior: 0,
        igv: 0,
        descuento: 0,
        descuento_life: 0,
      },
    },
    {
      description: [
        {
          id: 1,
          content: t("offers-banks.bbvaProgram"),
        },
        {
          id: 2,
          content: t("offers-banks.bbvaConditions"),
        },
        {
          id: 3,
          content: t("offers-banks.bbvaInstallments"),
        },
        {
          id: 4,
          content: t("offers-banks.bbvaValidity"),
        },
        {
          id: 5,
          content: t("offers-banks.bbvaPayment"),
        },
        {
          id: 6,
          content: t("offers-banks.bbvaDisclaimer"),
        },
      ],
      id: 3,
      nombre: "PROMOCION `BBVA`",
      redireccion: `/${i18n.language}/${t("routes.offers")}/bbva-beneficios`,
      card: {
        tipo_disenio: {
          id: 1,
          titulo: "Oferta con color de fondo",
        },
        titulo_card: "",
        condicion_abajo_precio: "",
        texto_encima_precio: "",
        valor: 35,
        up_to_quotes: "12",
        titulo: "Disfruta",
        subtitulo: "Comprando con tus tarjetas",
        logo: {
          name: "logo-bbva",
          path: "https://s3.us-east-1.amazonaws.com/ca-webprod/media/logo-bbva.webp",
          width: 1120,
          height: 402,
          size: 17486,
          title: "logo-bbva",
          alt: "logo-bbva",
          description: null,
          caption: null,
        },
        img: null,
        color: "rgba(14, 69, 126, 1)",
        color_secundario: "rgba(14, 69, 126, 1)",
        color_fuente: "rgba(255, 255, 255, 1)",
        precio: 0,
        precio_anterior: 0,
        igv: 0,
        descuento: 0,
        descuento_life: 0,
      },
    },
    {
      description: [
        {
          id: 1,
          content: t("offers-banks.dinersProgram"),
        },
        {
          id: 2,
          content: t("offers-banks.dinersConditions"),
        },
        {
          id: 3,
          content: t("offers-banks.dinersInstallments"),
        },
        {
          id: 4,
          content: t("offers-banks.dinersValidity"),
        },
        {
          id: 5,
          content: t("offers-banks.dinersPayment"),
        },
        {
          id: 6,
          content: t("offers-banks.dinersDisclaimer"),
        },
      ],
      id: 3,
      nombre: "PROMOCION DINNERS ",
      redireccion: `/${i18n.language}/${t("routes.offers")}/privilegios-diners`,
      card: {
        tipo_disenio: {
          id: 1,
          titulo: "Oferta con color de fondo",
        },
        titulo_card: "",
        condicion_abajo_precio: "",
        texto_encima_precio: "",
        valor: 32,
        up_to_quotes: "6",
        titulo: "Privilegios",
        subtitulo: "Y hasta 6 cuotas sin intereses",
        logo: {
          name: "diners-club-logo",
          path: "https://s3.us-east-1.amazonaws.com/ca-webprod/media/diners-club-logo.webp",
          width: 1000,
          height: 259,
          size: 47032,
          title: "Diners Club Logo",
          alt: "Diners Club Logo",
          description: null,
          caption: null,
        },
        img: null,
        color: "rgba(73, 125, 156, 1)",
        color_secundario: "rgba(73, 125, 156, 1)",
        color_fuente: "rgba(255, 255, 255, 1)",
        precio: 0,
        precio_anterior: 0,
        igv: 0,
        descuento: 0,
        descuento_life: 0,
      },
    },
    {
      description: [
        {
          id: 1,
          content: t("offers-banks.scotiabankProgram"),
        },
        {
          id: 2,
          content: t("offers-banks.scotiabankConditions"),
        },
        {
          id: 3,
          content: t("offers-banks.scotiabankInstallments"),
        },
        // {
        //   id: 4,
        //   content: t("offers-banks.dinersValidity"),
        // },
        // {
        //   id: 5,
        //   content: t("offers-banks.dinersPayment"),
        // },
        {
          id: 6,
          content: t("offers-banks.scotiabankDisclaimer"),
        },
      ],
      id: 3,
      nombre: "PROMOCION SCOTIABANK ",
      redireccion: `/${i18n.language}/${t("routes.offers")}/scotiabank`,
      card: {
        tipo_disenio: {
          id: 1,
          titulo: "Oferta con color de fondo",
        },
        titulo_card: "",
        condicion_abajo_precio: "",
        texto_encima_precio: "",
        valor: 32,
        titulo: "Disfruta",
        subtitulo: "Pagando con tus tarjetas",
        logo: {
          name: "scotiabnk-logo-blanco",
          path: "https://s3.us-east-1.amazonaws.com/ca-webprod/Promociones/scotiabnk-logo-blanco.png",
          width: 1303,
          height: 302,
          size: 31882,
          title: "scotiabnk-logo-blanco",
          alt: "scotiabnk-logo-blanco",
          description: null,
          caption: null,
        },
        img: null,
        color: "rgba(255, 9, 20, 1)",
        color_secundario: "rgba(255, 9, 20, 1)",
        color_fuente: "rgba(255, 255, 255, 1)",
        precio: 0,
        precio_anterior: 0,
        igv: 0,
        descuento: 0,
        descuento_life: 0,
      },
    },
    {
      description: [
        {
          id: 1,
          content: t("offers-banks.ohProgram"),
        },
        {
          id: 2,
          content: t("offers-banks.ohConditions"),
        },
        {
          id: 3,
          content: t("offers-banks.ohInstallments"),
        },
        // {
        //   id: 4,
        //   content: t("offers-banks.ohValidity"),
        // },
        // {
        //   id: 5,
        //   content: t("offers-banks.ohPayment"),
        // },
        {
          id: 6,
          content: t("offers-banks.ohDisclaimer"),
        },
      ],
      id: 3,
      nombre: "PROMOCION OH ",
      redireccion: `/${i18n.language}/${t("routes.offers")}/oh-beneficios`,
      card: {
        tipo_disenio: {
          id: 1,
          titulo: "Oferta con color de fondo",
        },
        titulo_card: "",
        condicion_abajo_precio: "",
        texto_encima_precio: "",
        valor: 32,
        titulo: "Viaja y disfruta",
        subtitulo: "Comprando con tu tarjeta",
        logo: {
          name: "logo-tarjeta-oh",
          path: "https://s3.us-east-1.amazonaws.com/ca-webprod/Promociones/logo-tarjeta-oh.png",
          width: 787,
          height: 364,
          size: 20868,
          title: "logo-tarjeta oh",
          alt: "logo-tarjeta oh",
          description: "logo-tarjeta oh",
          caption: null,
        },
        img: null,
        color: "rgba(66, 117, 145, 1)",
        color_secundario: "rgba(66, 117, 145, 1)",
        color_fuente: "rgba(255, 255, 255, 1)",
        precio: 0,
        precio_anterior: 0,
        igv: 0,
        descuento: 0,
        descuento_life: 0,
      },
    },
  ];

  const bannerPromotionQuota = [
    {
      id: 166,
      titulo: "",
      subtitulo: "",
      subtitulo_2: "",
      color_fondo_logo: null,
      img_desktop: {
        name: "banner-cuotas-sin-intereses",
        path: "https://s3.us-east-1.amazonaws.com/ca-webprod/media/banner-cuotas-sin-intereses.webp",
        width: 4312,
        height: 1468,
        size: 4047747,
        title: null,
        alt: "banner-cuotas-sin-intereses",
        description: null,
        caption: null,
      },
      img_mobile: {
        name: "banner-cuotas-sin-intereses",
        path: "https://s3.us-east-1.amazonaws.com/ca-webprod/media/banner-cuotas-sin-intereses-mobile.webp",
        width: 4312,
        height: 1468,
        size: 4047747,
        title: null,
        alt: "banner-cuotas-sin-intereses",
        description: null,
        caption: null,
      },
      descuento: "",
      descripcion_boton: "",
      redireccion_boton: "",
      imagen_secundaria_1: null,
      imagen_secundaria_2: null,
      img_logos: [],
      tipo_banner: {
        id: 5,
        titulo: "Solo imagen",
      },
    },
    // {
    //   id: 1,
    //   titulo: t("offers-banks.interestFreeInstallments"),
    //   subtitulo: t("offers-banks.enjoyYourVacation"),
    //   color_fondo_logo: "rgb(47, 28, 216)",
    //   img_desktop: {
    //     name: "ambiente-bar",
    //     path: bankEntities.background,
    //     width: 354,
    //     height: 405,
    //     size: 302962,
    //     title: "ambiente-bar",
    //     alt: "ambiente-bar",
    //     description: "ambiente-bar",
    //     caption: "ambiente-bar",
    //   },
    //   img_mobile: null,
    //   descuento: "",
    //   descripcion_boton: "",
    //   redireccion_boton: "",
    //   img_logos: [
    //     {
    //       id: 1,
    //       path: bankEntities.bcpWhite,
    //       alt: "bcp",
    //       title: "bcp",
    //       color: "rgb(47, 28, 216)",
    //     },
    //     {
    //       id: 2,
    //       path: bankEntities.ibkWhite,
    //       alt: "ibk",
    //       title: "ibk",
    //       color: "",
    //     },
    //     {
    //       id: 3,
    //       path: bankEntities.bbvaWhite,
    //       alt: "bbva",
    //       title: "bbva",
    //       color: "",
    //     },
    //     {
    //       id: 4,
    //       path: bankEntities.dinnersWhite,
    //       alt: "dinners",
    //       title: "dinners",
    //       color: "",
    //     },
    //   ],
    //   tipo_banner: {
    //     id: 1,
    //     titulo: "bancos",
    //   },
    // },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BannerSlider data={bannerPromotionQuota} />

      <Section title={t("offers-banks.yourTrip")}>
        <div className="quota">
          <Text
            type="paragraph"
            text={t("offers-banks.dontWait")}
            className="quota__description"
          />
          <Text
            type="paragraph"
            text={t("offers-banks.stopDreaming")}
            className="quota__description"
          />
          <Text
            type="paragraph"
            text={t("offers-banks.notApplicable")}
            className="quota__description"
          />
        </div>
      </Section>

      <Section bgColor="#F5F5F5" isTitle={false}>
        <ListCards list={listPromotionQuota} isList />
      </Section>
    </>
  );
};

export default PromotionsQuota;
